import { TODO, ACMEResponse } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IScope, ITimeoutService } from 'angular';
import { ApiService } from '@b2b/common/services/api/types';
import { NoticeFactory } from '@b2b/common/factories/notice';

OrdersRefundController.$inject = [
  '$scope',
  '$state',
  '$filter',
  '$uibModal',
  '$timeout',
  'ApiService',
  'CalendarService',
  'OrderService',
  'HelpersService',
  'NoticeFactory',
  'OrderData',
  'UserPreferencesService',
];

function OrdersRefundController(
  $scope: IScope & { ordersRefund: TODO },
  $state: StateService,
  $filter: IFilterService,
  $uibModal: TODO,
  $timeout: ITimeoutService,
  ApiService: ApiService,
  CalendarService: TODO,
  OrderService: TODO,
  HelpersService: TODO,
  NoticeFactory: NoticeFactory,
  OrderData: { data: ACMEResponse<TODO> },
  UserPreferencesService: TODO
) {
  const ctrl = {
    model: {} as TODO,
    refundModal: {} as TODO,
    notes: '',
    isProcessing: false,
    sendEmail: true,
    totalQuantity: 0,
    totalAmount: 0,
    incidentReasonCodes: [],
    selectedIncidentReasonCode: null,
    getItemType: OrderService.getItemType,
    dateFormat: UserPreferencesService.getDateFormat('tinyDate', 'dateFormat'),
    hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),
    notice: new NoticeFactory(),
    details: {
      columns: 3,
      data: 'ordersRefund.model',
      sorting: true,
      include: ['orderNumber', 'phoneNumber', 'email', 'contactFirstName', 'contactLastName'],
    },
    orderNotes: {
      columns: 1,
      data: 'ordersRefund.model',
      include: ['notes'],
      mappings: {
        notes: 'Order Notes',
      },
    },
    voucherNumber: '',
    

    init: function () {
      $scope.$emit('Application::contentTitleChange', {
        title: 'Cancel Order and Refund',
        buttonLeft: {
          label: 'Cancel',
          action: function () {
            ctrl.cancel();
          },
        },
        buttonRight: {
          label: 'Confirm Cancellation and Refund',
          action: function () {
            ctrl.complete();
          },
        },
      });

      if (OrderData && OrderData.data.success) {
        ctrl.success.init(OrderData);
      } else {
        ctrl.error.init(OrderData);
      }

      ctrl.getIncidentReasonCodes();
    },

    getIncidentReasonCodes: function () {
      ApiService.tenant.reasons.list().then(ctrl.success.getIncidentReasonCodes, ctrl.error.getIncidentReasonCodes);
    },

    hasIncidentReasonCodes: function () {
      return ctrl.incidentReasonCodes instanceof Array && ctrl.incidentReasonCodes.length;
    },

    resetModel: function () {
      var i, ii, j, jj;

      ctrl.totalQuantity = 0;
      ctrl.totalAmount = 0;

      for (i = 0, ii = ctrl.model.eventItems.length; i < ii; i++) {
        for (j = 0, jj = ctrl.model.eventItems[i].items.length; j < jj; j++) {
          ctrl.model.eventItems[i].items[j].refundQuantity = 0;
          ctrl.model.eventItems[i].items[j].refundAmount = 0;
        }

        ctrl.model.eventItems[i].refundQuantity = 0;
        ctrl.model.eventItems[i].refundAmount = 0;
      }
    },

    process: function (order) {
      var i, ii, j, jj;

      for (i = 0, ii = order.eventItems.length; i < ii; i++) {
        for (j = 0, jj = order.eventItems[i].items.length; j < jj; j++) {
          order.eventItems[i].items[j].refundQuantity = 0;
          order.eventItems[i].items[j].refundAmount = 0;
        }

        order.eventItems[i].refundQuantity = 0;
        order.eventItems[i].refundAmount = 0;

        if (order.eventItems[i].eventDate) {
          order.eventItems[i].startDate = $filter('date')(
            CalendarService.parseDate(order.eventItems[i].eventDate),
            ctrl.dateFormat
          );
          order.eventItems[i].startHour = $filter('date')(
            CalendarService.parseDate(order.eventItems[i].eventDate),
            ctrl.hourFormat
          );
        } else {
          order.eventItems[i].startDate = 'Date N/A';
          order.eventItems[i].startHour = 'Time N/A';
        }
      }

      return order;
    },

    calculateRefunds: function () {
      for (let i = 0, ii = ctrl.model.eventItems.length; i < ii; i++) {
        for (let j = 0, jj = ctrl.model.eventItems[i].items.length; j < jj; j++) {
          if (ctrl.model.eventItems[i].items[j].itemType !== "RebookingFee") {
            ctrl.model.eventItems[i].items[j].refundQuantity = ctrl.model.eventItems[i].items[j].quantity;
            ctrl.calculateTotal(ctrl.model.eventItems[i].items[j]);
          }
        }
      }
    },

    cancel: function () {
      ctrl.resetModel();
      window.history.go(-1);
    },

    calculateTotal: function (item) {
      let total;

      if (item.refundQuantity > item.quantity) {
        item.refundQuantity = item.quantity;
      }

      if (item.discountedUnitPrice) {
        total = item.refundQuantity * HelpersService.currencyFloatToInteger(item.discountedUnitPrice);
      } else {
        total = item.refundQuantity * HelpersService.currencyFloatToInteger(item.unitPrice);
      }
      item.refundAmount = HelpersService.integerToCurrencyFloat(total);

      ctrl.calculateSubTotals();
    },

    calculateSubTotals: function () {
      let amount = 0,
        quantity = 0,
        totalAmount = 0,
        totalQuantity = 0;

      for (let i = 0, ii = ctrl.model.eventItems.length; i < ii; i++) {
        amount = 0;
        quantity = 0;

        for (let j = 0, jj = ctrl.model.eventItems[i].items.length; j < jj; j++) {
          quantity += ctrl.model.eventItems[i].items[j].refundQuantity;
          amount += HelpersService.currencyFloatToInteger(ctrl.model.eventItems[i].items[j].refundAmount);
        }
        totalAmount += amount;
        totalQuantity += quantity;
        ctrl.model.eventItems[i].refundQuantity = quantity;
        ctrl.model.eventItems[i].refundAmount = HelpersService.integerToCurrencyFloat(amount);
      }
      ctrl.totalQuantity = totalQuantity;
      ctrl.totalAmount = HelpersService.integerToCurrencyFloat(totalAmount);
    },

    getRefundQuantity: function (ticket) {
      return ticket.quantity;
    },

    getRefundAmount: function () {
      return ctrl.totalAmount - ctrl.model.orderBalance;
    },

    getRefundItems: function () {
      var items: TODO[] = [],
        code;

      for (let i = 0, ii = ctrl.model.eventItems.length; i < ii; i++) {
        for (let j = 0, jj = ctrl.model.eventItems[i].items.length; j < jj; j++) {
          code = {
            orderItemId: ctrl.model.eventItems[i].items[j].orderItemId,
            quantity: ctrl.model.eventItems[i].items[j].refundQuantity,
          };

          if (ctrl.selectedIncidentReasonCode) {
            code.incidentReasonCode = ctrl.selectedIncidentReasonCode;
          }

          items.push(code);
        }
      }

      return items;
    },

    complete: function () {
      ctrl.notice.hideSuccessMessages();
      ctrl.notice.hideErrorMessages();

      if (ctrl.totalQuantity > 0) {
        if (ctrl.getRefundAmount() > 0) {
          ctrl.refundModal = $uibModal.open({
            templateUrl: 'views/application/views/orders/refund/modals/confirm.tpl.html',
            controller: 'OrdersRefundConfirmModalController',
            resolve: {
              currentRefund: function () {
                return {
                  total: ctrl.totalAmount,
                  quantity: ctrl.totalQuantity,
                };
              },
            },
          });

          // Invoked when modal completes with close(params)
          ctrl.refundModal.result.then(
            function () {
              ctrl.refund();
            },
            function () {
              // Do nothing
            }
          );
        } else {
          ctrl.refund();
        }
      } else {
        ctrl.notice.showErrorMessages([{ message: 'You must add tickets to your refund.' }]);
      }
    },

    refund: function () {
      var refund: TODO = {
        orderId: ctrl.model.orderId,
        noEmail: !ctrl.sendEmail,
        notes: (ctrl.model.notes ? '\n' : '') + (ctrl.notes || ''),
        refundItems: [],
      };

      ctrl.isProcessing = true;

      if (ctrl.selectedIncidentReasonCode) {
        refund.incidentReasonCode = ctrl.selectedIncidentReasonCode;
      }

      ApiService.refunds.refund(refund).then(ctrl.success.refund, ctrl.error.refund);
    },

    success: {
      init: function (response) {
        ctrl.model = ctrl.process(response.data.payload);
        ctrl.voucherNumber = ctrl.model.paymentId;
        //calculate totals and refunds for the cancellation
        ctrl.calculateRefunds();
      },
      refund: function (response) {
        ctrl.isProcessing = false;
        ctrl.resetModel();
        $state.go('application.orders.detail.summary', { orderId: response.data.payload.order.id });
      },
      getIncidentReasonCodes: function (response) {
        $timeout(function () {
          ctrl.incidentReasonCodes = response.data.payload;
        }, 0);
      },
    },

    error: {
      init: function (response) {
        // noop
      },
      refund: function (response) {
        ctrl.isProcessing = false;
        ctrl.notice.showErrorMessages([{ message: 'An error has occurred: ' + response.data.error }]);
      },
      getIncidentReasonCodes: function (response) {
        // Ignore this error
      },
    },
  };
  $scope.ordersRefund = ctrl;
  ctrl.init();
}

export const OrdersRefundControllerModule = angular
  .module('acme.view.application.orders.refund.controllers', [
    'ui.router',
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.order',
    'acme.common.service.calendar',
    'acme.common.service.helpers',
    'acme.common.factory.notice',
    'acme.common.service.userPreferences',
    'acme.view.application.orders.refund.confirmModal.controllers',
  ])
  .controller('OrdersRefundController', OrdersRefundController).name;
